import { useState } from "react";
import {
  EscrowConsent, Field, FileField, ID_TYPES, Input, NG_STATES, OnboardShell, Select, Textarea, useKycSubmit,
} from "@/pages/onboarding/shared";
import { useAuth } from "@/context/AuthContext";

const STEPS = ["Personal", "Identity", "Address & consent"];

export default function ReferralClientKyc() {
  const { user } = useAuth();
  const [step, setStep] = useState(0);
  const { busy, submit } = useKycSubmit("/api/kyc/referral-client");
  const [f, setF] = useState({
    full_name: user?.full_name || "",
    phone: user?.phone || "",
    email: user?.email || "",
    id_type: "",
    id_number: "",
    id_document_file_id: "",
    physical_address: "",
    city: "",
    state: "",
    referrer_code: "",
    escrow_terms_accepted: false,
  });
  const set = (k) => (v) => setF((p) => ({ ...p, [k]: v }));

  const canNext = [
    f.full_name && f.phone && f.email,
    f.id_type && f.id_number && f.id_document_file_id,
    f.physical_address && f.city && f.state && f.escrow_terms_accepted,
  ][step];

  return (
    <OnboardShell
      title="Referral Client verification"
      subtitle="Complete your baseline KYC so you can fund care for your beneficiary."
      steps={STEPS}
      step={step}
      onBack={() => setStep(step - 1)}
      onNext={() => (step === STEPS.length - 1 ? submit({ ...f, referrer_code: f.referrer_code || null }) : setStep(step + 1))}
      busy={busy}
      canNext={canNext}
      submitLabel="Submit for review"
    >
      {step === 0 && (
        <>
          <Field label="Full name"><Input value={f.full_name} onChange={(e) => set("full_name")(e.target.value)} data-testid="rc-fullname-input" /></Field>
          <Field label="Phone number"><Input value={f.phone} onChange={(e) => set("phone")(e.target.value)} data-testid="rc-phone-input" /></Field>
          <Field label="Email address"><Input type="email" value={f.email} onChange={(e) => set("email")(e.target.value)} data-testid="rc-email-input" /></Field>
          <Field label="Referral code (optional)"><Input value={f.referrer_code} onChange={(e) => set("referrer_code")(e.target.value.toUpperCase())} placeholder="CN-XXXXXXXX" data-testid="rc-referral-code-input" /></Field>
        </>
      )}
      {step === 1 && (
        <>
          <Field label="Government ID type"><Select value={f.id_type} onChange={set("id_type")} options={ID_TYPES} testId="rc-idtype-select" /></Field>
          <Field label="ID number"><Input value={f.id_number} onChange={(e) => set("id_number")(e.target.value)} data-testid="rc-idnumber-input" /></Field>
          <FileField label="ID document photo" value={f.id_document_file_id} onChange={set("id_document_file_id")} purpose="GOVERNMENT_ID" testId="rc-iddoc-upload" />
        </>
      )}
      {step === 2 && (
        <>
          <Field label="Physical address"><Textarea value={f.physical_address} onChange={(e) => set("physical_address")(e.target.value)} data-testid="rc-address-input" /></Field>
          <Field label="City / town"><Input value={f.city} onChange={(e) => set("city")(e.target.value)} data-testid="rc-city-input" /></Field>
          <Field label="State"><Select value={f.state} onChange={set("state")} options={NG_STATES} testId="rc-state-select" /></Field>
          <EscrowConsent checked={f.escrow_terms_accepted} onChange={set("escrow_terms_accepted")} testId="rc-escrow-checkbox" />
        </>
      )}
    </OnboardShell>
  );
}
